import { STATUS_STYLES } from "@/constants";

export default function StatusBadge({ status, testid }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES["Demande"];
  return (
    <span
      data-testid={testid || `status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {status}
    </span>
  );
}
